export default __webpack_public_path__ + "static/media/Journal_Icon.04f9bb9c.svg";